import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="CurrentColor"
                d="M13.656 12.212c.41.41.41 1.072 0 1.481a1.052 1.052 0 01-1.485 0L7 8.5l-5.207 5.193a1.052 1.052 0 01-1.485 0 1.045 1.045 0 010-1.481L5.517 7.02.307 1.788a1.045 1.045 0 010-1.481 1.052 1.052 0 011.485 0L7.001 5.54 12.208.348a1.052 1.052 0 011.485 0c.41.408.41 1.072 0 1.48L8.484 7.02l5.172 5.192z"
            />
        </svg>
    );
};

export default React.memo(Close);
